import { getEnv } from './env';

export function deleteAllCookies() {
  document.cookie.split(';').forEach(function (c) {
    if (c.includes('build_number')) {
      return;
    }
    c.split('=')[0] && deleteCookieValue(c.split('=')[0]);
  });
}

export function setCookieValue(name, value) {
  document.cookie = `${name}=${value}; Path=/;`;
}

export function deleteCookieValue(name) {
  document.cookie = `${name}=; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

export function deleteWrongCognitoDomainCookies(poolId: string) {
  const domain = getEnv('VUE_APP_AUTH_COOKIE_DOMAIN');
  if (domain === 'goldcast.io') {
    return;
  }
  document.cookie.split(';').forEach(function (c) {
    if (c.includes(poolId)) {
      document.cookie = c
        .replace(/^ +/, '')
        .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';domain=goldcast.io;path=/');
    }
  });
}
